import{sqrt}from"../math.js";export default{draw(context,size){const w=sqrt(size),x=-w/2;context.rect(x,x,w,w)}};